var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9191 11.473L17.7512 16.293C18.1431 16.684 18.1431 17.316 17.7512 17.707C17.5557 17.902 17.299 18 17.0424 18C16.7857 18 16.5291 17.902 16.3336 17.707L11.5016 12.887C10.5181 13.585 9.31912 14 8.01988 14C4.6986 14 2.00488 11.313 2.00488 8C2.00488 4.687 4.6986 2 8.01988 2C11.3412 2 14.0349 4.687 14.0349 8C14.0349 9.296 13.6188 10.492 12.9191 11.473ZM4.00988 8C4.00988 10.209 5.80536 12 8.01988 12C10.2344 12 12.0299 10.209 12.0299 8C12.0299 5.791 10.2344 4 8.01988 4C5.80536 4 4.00988 5.791 4.00988 8Z",
    fill: "#F5B335"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26681_226546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9191 11.473L17.7512 16.293C18.1431 16.684 18.1431 17.316 17.7512 17.707C17.5557 17.902 17.299 18 17.0424 18C16.7857 18 16.5291 17.902 16.3336 17.707L11.5016 12.887C10.5181 13.585 9.31912 14 8.01988 14C4.6986 14 2.00488 11.313 2.00488 8C2.00488 4.687 4.6986 2 8.01988 2C11.3412 2 14.0349 4.687 14.0349 8C14.0349 9.296 13.6188 10.492 12.9191 11.473ZM4.00988 8C4.00988 10.209 5.80536 12 8.01988 12C10.2344 12 12.0299 10.209 12.0299 8C12.0299 5.791 10.2344 4 8.01988 4C5.80536 4 4.00988 5.791 4.00988 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26681_226546)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.28644256aaf94f6bc1007fa7fcf0562b.svg";
export { ForwardRef as ReactComponent };